<!-- Composed screen frame — markup mirrors application.component.html so styling
     stays in sync via the global .tab-status-bar, .operation-status-notice and
     .tab-heading classes. showcaseReadOnlyPreview keeps every nested control inert
     while preserving hover and PrimeNG tooltips. -->
<div class="recovery-screen-frame" [class.frameless]="frameless" showcaseReadOnlyPreview [attr.aria-label]="ariaLabel">
  <!-- Main tab strip + action buttons. Surfaces the per-phase action-button
       enable/disable state without orchestrating a real recovery. -->
  <div class="recovery-screen-tab-bar-wrapper">
    <div class="overview-tabs-bar" role="tablist">
      <button
        type="button"
        class="overview-tab"
        [class.active]="activeTab === 'backup'"
        role="tab"
        [attr.aria-selected]="activeTab === 'backup'"
      >
        <svg lucideCloudUpload class="mobile-tab-icon"></svg>
        <span class="tab-label">Backup</span>
      </button>
      <button
        type="button"
        class="overview-tab"
        [class.active]="activeTab === 'recovery'"
        role="tab"
        [attr.aria-selected]="activeTab === 'recovery'"
      >
        <svg lucideCloudDownload class="mobile-tab-icon"></svg>
        <span class="tab-label">Recovery Environment</span>
      </button>
      <div class="tab-bar-actions">
        <showcase-tab-bar-actions [flags]="flags"></showcase-tab-bar-actions>
      </div>
    </div>
  </div>

  @if (showRefreshBar) {
    <!-- Static mirror of application.component.html's .overview-refresh-bar — the
         self-refresh reassurance + hard-reload escape hatch that sits between the
         tab strip and the status bar. -->
    <div class="overview-refresh-bar">
      <div class="auto-refresh-indicator">
        <a class="reload-now-link" role="button" tabindex="0"><svg lucideRefreshCw></svg></a>
        <span class="auto-refresh-text">Automatically updates every 60s </span>
      </div>
    </div>
  }

  <ng-content></ng-content>
</div>
